<template>
  <WithPaginationAndFilters :is-raised="false" :data="content">
    <template slot-scope="{ data, sortChange }">
      <ElTable
        :data="data"
        :default-sort="defaultSort"
        style="width: 100%;"
        @sort-change="sortChange"
      >
        <ElTableColumn v-if="showIndex" type="index" width="50" />
        <ElTableColumn
          v-for="column in columns"
          :key="column.slug"
          :prop="column.slug"
          sortable
          :min-width="column.minWidth"
          :label="column.title"
        />
      </ElTable>
    </template>
  </WithPaginationAndFilters>
</template>

<script>
import WithPaginationAndFilters from '@@/common/paginations/WithPaginationAndFilters';

export default {
  name: 'TableWidget',

  components: {
    WithPaginationAndFilters,
  },

  props: {
    columns: {
      type: Array,
      required: true,
      default() {
        return [];
      },
    },

    content: {
      type: Array,
      required: true,
      default() {
        return [];
      },
    },

    showIndex: {
      type: Boolean,
      default: true,
    },
    defaultSort: {
      type: Object,
      default: () => ({}),
    },
  },
};
</script>
